<template>
    <div>
        <v-container fluid pa-0 :class="{'pa-0': $route.path.includes('coupon')}">
            <v-flex xs12>
                <!--v-if="getSettings.enableOpenToPublic.value"-->
                <v-flex xs12>
                    <v-flex v-show="isHomeLoading" xs12 class="text-center center-loading-circle">
                        <span>
                            <v-progress-circular
                                indeterminate
                                :size="70"
                                :width="7"
                                :aria-label="$t('accessibility.loadingGeneric')"
                                class="screen-center"
                                color="primary" />
                        </span>
                    </v-flex>
                    <v-flex>
                        <router-view v-show="!isHomeLoading" />
                    </v-flex>
                </v-flex>
            </v-flex>
        </v-container>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'home',
    computed: {
        ...mapGetters({
            locale: 'locale',
            isHomeLoading: 'loading/isHomeLoading',
            getEstablishment: 'establishment/getEstablishment',
            getSettings: 'establishment/getSettings',
            getTexts: 'texts/getTexts',
        }),
    },
};
</script>
<style lang="scss">
    #body-wrapper {
        /* background-size: cover;
        background: #FFF url('../../static/img/clicsante_background_top.jpg') top no-repeat;
        */
    }

    .deactivated-text-card {
        max-height: 500px;
        overflow-y: auto;
    }

    .deactivated-text {
        border-radius: 5px;

        strong {
            font-weight: bold;
        }

        p {
            padding: 5px 0;
            font-size: 14px;
        }

        ul, ol {
            padding: 5px 25px;
            font-size: 14px;
        }

        ul li {
            list-style-type: disc;
        }

        ol li {
            list-style-type: decimal;
        }

        .popup-title {
            display: initial;
            font-weight: bold;
            font-size: 120%;
        }
    }
</style>
